import {
  EnumEntityReferenceType,
  EnumOwnerType,
  PersonDetailsQuery,
  usePersonNextPaymentQuery,
} from "gql/generated";
import { useLoggedInAs } from "shared/hooks";

export type UseNextPaymentProps = {
  person: PersonDetailsQuery["personDetails"];
};

export const useNextPayment = ({ person }: UseNextPaymentProps) => {
  const loggedInAs = useLoggedInAs();
  const storefrontId = loggedInAs?.entityId;

  const { data } = usePersonNextPaymentQuery({
    variables: {
      personId: person?._id ?? "",
      ...(loggedInAs &&
        loggedInAs.type === EnumOwnerType.Storefront && {
          entityId: storefrontId,
          type: EnumEntityReferenceType.Storefront,
        }),
    },
  });
  return {
    nextPayment: data?.personNextPayment,
  };
};
